import { render, staticRenderFns } from "./AssetDetailsView.vue?vue&type=template&id=fc8ae084"
import script from "./AssetDetailsView.vue?vue&type=script&lang=js"
export * from "./AssetDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports